export default Object.freeze({
  Form: 'form',
  FormConfig: 'form-config',
  FormStyle: 'form-style',
  FormPublicStyle: 'form-public-style',
  FormWizardStep: 'form-wizard-step',
  FormGroup: 'form-group',
  FormField: 'form-field',
  Action: 'action',
  ActionBehaviorCase: 'action-behavior-case',
  ActionCommandsBehaviorCase: 'action-commands-behavior-case',
  Variable: 'variable',
});
